import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useUIStore } from '../../store';
import api from '../../services/api';

const STATUS = {
  completed:       { bg: '#eaf4ef', color: '#2d6a4f', label: 'Entregado' },
  in_delivery:     { bg: '#fef3e2', color: '#b45309', label: 'En tránsito' },
  queued_offline:  { bg: '#fef3e2', color: '#b45309', label: '⚡ Cola offline' },
  pending_payment: { bg: '#eaf1fb', color: '#1a4e8c', label: 'Pago pendiente' },
  failed:          { bg: '#faeef4', color: '#9b2c5e', label: 'Fallido' },
  refunded:        { bg: '#eaf1fb', color: '#1a4e8c', label: 'Reembolsado' },
};

const PM_LABEL = {
  usdt_trc20: 'USDT TRC-20', btc: 'Bitcoin', btc_lightninglike: 'Lightning',
  zelle: 'Zelle', pix: 'Pix', mercadopago: 'Mercado Pago',
};

export default function TxDetailModal({ ref_ }) {
  const { closeTxDetail } = useUIStore();
  const navigate = useNavigate();
  const [tx, setTx] = useState(null);
  const [err, setErr] = useState('');

  useEffect(() => {
    api.get(`/api/v1/transactions/${ref_}`)
      .then(r => setTx(r.data))
      .catch(() => setErr('No se pudo cargar la transacción'));
  }, [ref_]);

  const s = STATUS[tx?.status] || STATUS.completed;
  const fmtDate = (iso) => iso ? new Date(iso).toLocaleString('es', { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' }) : '—';
  const pm = tx ? (PM_LABEL[String(tx.payment_method || '').toLowerCase()] || tx.payment_method || '—') : '—';

  return (
    <div onClick={(e) => e.target === e.currentTarget && closeTxDetail()}
      style={{ position: 'fixed', inset: 0, background: 'rgba(15,13,11,.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 500, backdropFilter: 'blur(3px)' }}>
      <div style={{ background: '#fff', borderRadius: 14, width: 440, maxWidth: '95vw', maxHeight: '90vh', overflowY: 'auto', boxShadow: '0 8px 32px rgba(15,13,11,.13)', animation: 'modalIn .2s ease' }}>
        <div style={{ padding: '20px 24px 16px', borderBottom: '1px solid #e2dbd0', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div style={{ fontFamily: 'Georgia,serif', fontSize: 18 }}>Detalle de transacción</div>
          <button onClick={closeTxDetail} style={{ width: 28, height: 28, borderRadius: 6, border: 'none', background: 'transparent', cursor: 'pointer', fontSize: 16, color: '#7a7060' }}>×</button>
        </div>

        {err && <div style={{ padding: 24, fontSize: 13, color: '#9b2c5e' }}>{err}</div>}
        {!tx && !err && <div style={{ padding: 24, fontSize: 13, color: '#7a7060' }}>Cargando…</div>}

        {tx && (
          <>
            <div style={{ padding: '20px 24px' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
                <div>
                  <div style={{ fontFamily: 'Georgia,serif', fontSize: 32, letterSpacing: '-.02em', lineHeight: 1 }}>${Number(tx.amount_usd).toFixed(2)}</div>
                  <div style={{ fontSize: 12, color: '#7a7060', marginTop: 4 }}>{String(tx.delivery_method || '').replace('_', ' ')}</div>
                </div>
                <span style={{ background: s.bg, color: s.color, fontSize: 11, fontWeight: 700, padding: '4px 10px', borderRadius: 20 }}>{s.label}</span>
              </div>

              {tx.delivery_otp && (
                <div style={{ background: '#0a0d0b', borderRadius: 12, padding: '16px 18px', marginBottom: 18, textAlign: 'center' }}>
                  <div style={{ fontSize: 10.5, fontWeight: 700, letterSpacing: '.09em', textTransform: 'uppercase', color: '#4bdf8e', marginBottom: 8 }}>Código de entrega</div>
                  <div style={{ fontFamily: 'monospace', fontSize: 34, fontWeight: 700, letterSpacing: 10, color: '#fff' }}>{tx.delivery_otp}</div>
                  <div style={{ fontSize: 12, color: '#9ba89f', marginTop: 8 }}>Compártelo solo con quien recibe el dinero. El agente lo pedirá al entregar.</div>
                </div>
              )}

              {[
                ['ID', tx.ref],
                ['Destinatario', tx.recipient_name || '—'],
                ['Provincia', tx.recipient_province || '—'],
                ['Teléfono', tx.recipient_phone],
                ['Monto enviado', `$${Number(tx.amount_usd).toFixed(2)}`],
                ['Fee', `$${Number(tx.fee_usd).toFixed(2)}`],
                ['Recibe en Cuba', tx.cup_to_deliver ? `${Number(tx.cup_to_deliver).toLocaleString('es')} CUP` : `$${Number(tx.net_usd).toFixed(2)}`],
                ['Pagado con', pm],
                ['Creada', fmtDate(tx.created_at)],
                ['Completada', fmtDate(tx.completed_at)],
              ].map(([k, v]) => (
                <div key={k} style={{ display: 'flex', justifyContent: 'space-between', padding: '10px 0', borderBottom: '1px solid #e2dbd0', fontSize: 13 }}>
                  <span style={{ color: '#7a7060', fontWeight: 500 }}>{k}</span>
                  <span style={{ fontWeight: 600, textAlign: 'right', fontFamily: k === 'ID' || k === 'Teléfono' ? 'monospace' : 'inherit', color: k === 'ID' ? '#c94a1e' : undefined }}>{v}</span>
                </div>
              ))}
            </div>
            <div style={{ padding: '14px 24px', borderTop: '1px solid #e2dbd0', display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
              <button onClick={closeTxDetail} style={{ padding: '9px 18px', borderRadius: 8, border: '1px solid #e2dbd0', background: 'transparent', fontSize: 13, fontWeight: 600, cursor: 'pointer' }}>Cerrar</button>
              <button onClick={() => { closeTxDetail(); navigate('/app/enviar'); }} style={{ padding: '9px 18px', borderRadius: 8, border: 'none', background: '#c94a1e', color: '#fff', fontSize: 13, fontWeight: 600, cursor: 'pointer' }}>Repetir envío</button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
